import * as React from 'react';
import { Branches, NoReferenceableOutputsMessage } from '../';
import { IDecision, IOperator, DOMHelper, IBranch } from '../../helpers';
import {
    DialogFooter,
    Button, ButtonType,
    IDropdownOption,
    MessageBar, MessageBarType
} from 'office-ui-fabric-react';
import store from '../../store/store';
import Collapsible from 'react-collapsible';

interface IProps {
    operators?: IOperator[];
    operatorTypes?: string[];
    outputOptions?: IDropdownOption[];
    decision: IDecision;
    branchEditIndex: number;
    editedBranch: IBranch;
    componentDialogToggle?: () => void;
    addBranch: () => void;
    saveEditedBranch: () => void;
    updateEditedBranch: (branch: IBranch) => void;
    setBranchEditIndex: (branchIndex: number) => void;
    deleteBranch: (index: number) => void;
    closeDialog: (save?: boolean) => void;
    branchIndex?: number;
    componentId?: string;
    toggleDecisionConfigDialog?: (componentId: string, previousOutputBlocks: any) => void;
    addOnly?: boolean;
    removeOnly?: boolean;
    overviewOnly?: boolean;
    previousOutputBlocks?: any;
    addBranchOnly?: () => void;
    removeBranchOnly?: (index: number, componentId: string) => void;
    dismissDialog?: () => void;
    conditions?: IBranch[];
}

export class DecisionConfig extends React.Component<IProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            showBranchEdit: false
        };
        this.changeShowBranchEdit = this.changeShowBranchEdit.bind(this);
    }

    changeShowBranchEdit(val?: boolean) {
        this.setState({
            showBranchEdit: val
        });
    }

    // manage actionConfigDialog modal state for action component
    decisionConfigDialogToggle() {
        let {
            componentId, outputOptions, toggleDecisionConfigDialog
        } = this.props;
        toggleDecisionConfigDialog(componentId, outputOptions);

    }

    public render() {

        let { closeDialog, decision,
            operators, operatorTypes, outputOptions,
            addBranch, saveEditedBranch, updateEditedBranch, deleteBranch,
            branchEditIndex, editedBranch, setBranchEditIndex, branchIndex, componentId, addOnly, removeOnly,
            toggleDecisionConfigDialog, previousOutputBlocks, addBranchOnly, dismissDialog, removeBranchOnly, overviewOnly, conditions
        } = this.props;

        if (!outputOptions.length) {
            return <NoReferenceableOutputsMessage />;
        }

        return (
            <div className={addOnly ? 'add-only-decision' : ''}>
                {/* <h3>Branches</h3> */}
                {addOnly ?
                    <div>
                        <Branches
                            operators={operators}
                            operatorTypes={operatorTypes}
                            decision={decision}
                            outputOptions={outputOptions}
                            addBranch={addBranch}
                            saveEditedBranch={saveEditedBranch}
                            updateEditedBranch={updateEditedBranch}
                            deleteBranch={deleteBranch}
                            branchEditIndex={branchEditIndex}
                            editedBranch={editedBranch}
                            setBranchEditIndex={setBranchEditIndex}
                            // branchIndex={branchIndex}
                            addOnly={addOnly}
                            closeDialog={closeDialog}
                            addBranchOnly={addBranchOnly}
                            toggleDecisionConfigDialog={toggleDecisionConfigDialog}
                            componentId={componentId}
                            previousOutputBlocks={previousOutputBlocks}
                        />
                    </div>
                    :
                    removeOnly
                        ? <div>
                            <Branches
                                operators={operators}
                                operatorTypes={operatorTypes}
                                decision={decision}
                                outputOptions={outputOptions}
                                addBranch={addBranch}
                                saveEditedBranch={saveEditedBranch}
                                updateEditedBranch={updateEditedBranch}
                                deleteBranch={deleteBranch}
                                branchEditIndex={branchEditIndex}
                                editedBranch={editedBranch}
                                setBranchEditIndex={setBranchEditIndex}
                                branchIndex={branchIndex}
                                addOnly={addOnly}
                                closeDialog={closeDialog}
                                addBranchOnly={addBranchOnly}
                                toggleDecisionConfigDialog={toggleDecisionConfigDialog}
                                componentId={componentId}
                                previousOutputBlocks={previousOutputBlocks}
                                removeBranchOnly={removeBranchOnly}
                                removeOnly={removeOnly}
                            />
                        </div>
                        :
                        overviewOnly ?

                            <div>

                                <Branches
                                    operators={operators}
                                    operatorTypes={operatorTypes}
                                    decision={decision}
                                    outputOptions={outputOptions}
                                    addBranch={addBranch}
                                    saveEditedBranch={saveEditedBranch}
                                    updateEditedBranch={updateEditedBranch}
                                    deleteBranch={deleteBranch}
                                    branchEditIndex={branchEditIndex}
                                    editedBranch={editedBranch}
                                    setBranchEditIndex={setBranchEditIndex}
                                    branchIndex={branchIndex}
                                    componentId={componentId}
                                    overviewOnly={overviewOnly}
                                />

                                {/* <DialogFooter>
                                    <Button tabIndex={1001} buttonType={ButtonType.normal} onClick={() => closeDialog(false)}>Cancel</Button>
                                    <Button tabIndex={1002} buttonType={ButtonType.primary} id="decision-config-save"
                                        onClick={() => closeDialog(true)} onBlur={() => { DOMHelper.focusOnFirstModalTabbableControl(); }}>Save</Button>
                                </DialogFooter> */}
                            </div>

                            :
                            <div>

                                <Branches
                                    operators={operators}
                                    operatorTypes={operatorTypes}
                                    decision={decision}
                                    outputOptions={outputOptions}
                                    addBranch={addBranch}
                                    saveEditedBranch={saveEditedBranch}
                                    updateEditedBranch={updateEditedBranch}
                                    deleteBranch={deleteBranch}
                                    branchEditIndex={branchEditIndex}
                                    editedBranch={editedBranch}
                                    setBranchEditIndex={setBranchEditIndex}
                                    branchIndex={branchIndex}
                                    componentId={componentId}
                                    toggleDecisionConfigDialog={toggleDecisionConfigDialog}
                                    previousOutputBlocks={previousOutputBlocks}
                                    closeDialog={closeDialog}
                                    conditions={conditions}
                                    showBranchEdit={this.state.showBranchEdit}
                                    changeShowBranchEdit={this.changeShowBranchEdit}
                                />

                                {/* <DialogFooter>
                                <Button tabIndex={1001} buttonType={ButtonType.normal} onClick={() => closeDialog(false)}>Cancel</Button>
                                <Button tabIndex={1002} buttonType={ButtonType.primary} id="decision-config-save"
                                    onClick={() => closeDialog(true)} onBlur={() => { DOMHelper.focusOnFirstModalTabbableControl(); }}>Save</Button>
                            </DialogFooter> */}
                            </div>

                    // <Collapsible
                    //     handleTriggerClick={() => {
                    //         dismissDialog();
                    //         setBranchEditIndex(null);
                    //         this.decisionConfigDialogToggle();
                    //     }}
                    //     // open={true} trigger={'Config'}>
                    //     open={componentId === store.getState().modalState.decisionConfig.componentId} trigger={
                    //         <Button buttonType={ButtonType.primary}
                    //             label='Configure this decision'
                    //             title='Configure this decision'
                    //             icon='Settings'
                    //             onClick={(e) => toggleDecisionConfigDialog(componentId, previousOutputBlocks)} />
                    //     }>

                    //     {/* {store.getState().modalState.decisionConfig.componenentId === componentId ? */}


                    //     {/* : null} */}
                    // </Collapsible>




                }


                {/* <Branches
                    operators={operators}
                    operatorTypes={operatorTypes}
                    decision={decision}
                    outputOptions={outputOptions}
                    addBranch={addBranch}
                    saveEditedBranch={saveEditedBranch}
                    updateEditedBranch={updateEditedBranch}
                    deleteBranch={deleteBranch}
                    branchEditIndex={branchEditIndex}
                    editedBranch={editedBranch}
                    setBranchEditIndex={setBranchEditIndex}
                // branchIndex={branchIndex}


                />

                <DialogFooter>
                    <Button tabIndex={1001} buttonType={ButtonType.normal} onClick={() => closeDialog(false)}>Cancel</Button>
                    <Button tabIndex={1002} buttonType={ButtonType.primary} id="decision-config-save"
                        onClick={() => closeDialog(true)} onBlur={() => { DOMHelper.focusOnFirstModalTabbableControl(); }}>Save</Button>
                </DialogFooter> */}



            </div >
        );

    }

}


// WEBPACK FOOTER //
// ./source/ts/components/decisions/decision-config.tsx